import { render } from "./NumberSelectorWidget.vue?vue&type=template&id=060caeaa"
import script from "./NumberSelectorWidget.vue?vue&type=script&lang=js"
export * from "./NumberSelectorWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__